'use strict';

import React from 'react';

require('styles//SoftwarePage.css');

class SoftwarePageComponent extends React.Component {
  render() {
    return (
      <div className="softwarepage-component">
        <div className="header">
          <h2 className="page-title">Soluções à Medida</h2>
          <div className="page-description">
            <p>
              A Labor Team desenvolve soluções de software para responder às necessidades de cada empresa. Os programas desenvolvidos possuem funcionalidades que permitem uma melhor resposta à especificidade de cada negócio. Estas soluções podem ficar acesíveis nos computadores da empresa ou em qualquer dispositivo com acesso à internet (telemóvel, tablet, portátil).
            </p>
            <p>
              O objetivo final da nossa empresa é acrescentar valor ao serviço prestado pela sua.
            </p>
          </div>
        </div>

        <section>
          <h3 className="section-title">Desenvolvemos</h3>
          <div className="grid">
            <div className="item">
              <div className="icon">
                <img src="/static/images/websites.svg" alt="Desenvolvemos Websites"/>
                <h3>Websites</h3>
              </div>
              <p>Desenvolvemos sites únicos, que se adaptam aos vários ecrãs, com a última tecnologia e com a melhor qualidade.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/lojasonline.svg" alt="Desenvolvemos Lojas Online"/>
                <h3>Lojas Online</h3>
              </div>
              <p>Desenvolvemos lojas online para todo o tipo de negócios.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/apps.svg" alt="Desenvolvemos Aplicações"/>
                <h3>Aplicações</h3>
              </div>
              <p>Desenvolvemos aplicações que permitirão aumentar a produtividade dos seus funcionários, para qualquer plataforma.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/appsintsage.svg" alt="Desenvolvemos Aplicações Integradas com a SAGE"/>
                <h3>Integração SAGE</h3>
              </div>
              <p>Desenvolvemos aplicações que podem integrar com aplicações SAGE.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/appsintzs.svg" alt="Desenvolvemos Aplicações Integradas com a ZoneSoft"/>
                <h3>Integração ZoneSoft</h3>
              </div>
              <p>Desenvolvemos aplicações que podem integrar com aplicações ZoneSoft.</p>
            </div>
                                    <div className="item">
              <div className="icon">
                <img src="/static/images/aplicacoesoutros.svg" alt="Desenvolvemos aplicações que podem integrar com diversos softwares."/>
                <h3>Integração</h3>
              </div>
              <p>Desenvolvemos aplicações que podem integrar com diversos softwares.</p>
            </div>
                        <div className="item">
              <div className="icon">
                <img src="/static/images/analisevendas.svg" alt="Desenvolvemos ferramentas que permitem a análise de vendas do seu negócio, para que possa investir de forma mais eficiente."/>
                <h3>Análise de Vendas</h3>
              </div>
              <p>Desenvolvemos ferramentas que permitem a análise de vendas do seu negócio, para que possa investir de forma mais eficiente.</p>
            </div>
                        <div className="item">
              <div className="icon">
                <img src="/static/images/analisestock.svg" alt="Desenvolvemos ferramentas que permitem analisar e gerir o stock para manutenção de encomendas."/>
                <h3>Análise de Stock</h3>
              </div>
              <p>Desenvolvemos ferramentas que permitem analisar e gerir o stock para manutenção de encomendas.</p>
            </div>
          </div>
        </section>

        <section>
          <h1 className="section-title" id="solutions">Soluções</h1>

          <div className="solution">
            <img className="solution-logo" src="/static/images/ltconversorgco50c.svg" />
            <div className="solution-info">
              <h3 className="title">LT Conversor Sage GCO - 50c</h3>
              <div>
                <p>Transfira os dados do SAGE GCO para o Sage 50c através da solução LT Conversor Sage GCO - 50c desenvolvido pela Labor Team.</p>
                <p>Esta solução permite a migração da seguinte informação:</p>
                <ul>
                  <li>todo o histórico de vendas existentes no GCO, incluindo as propriedades/lotes/números de série/cores e tamanhos dos artigos</li>
                  <li>stock existente à data da migração custeado ao PMC</li>
                  <li>pendentes de clientes e fornecedores (documento a documento) à data da migração</li>
                  <li>encomendas pendentes de clientes à data da migração</li>
                  <li>encomendas pendentes a fornecedores à data da migração</li>
                  <li>orçamentos pendentes à data da migração</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="solution">
            <img className="solution-logo" src="/static/images/ltanalytics.svg" />
            <div className="solution-info">
              <h3 className="title">LT Analytics</h3>
              <div>
                <p>
                  Sabe quais são os 10 produtos/serviços mais vendidos na sua empresa? E quais os que lhe trazem mais lucro num determinado espaço de tempo? Ainda não? Então temos a ferramenta que precisa para investir de forma mais inteligente no seu negócio.
                </p>
                <p>
                  O LT Analytics é uma ferramenta que serve para analisar a eficácia das vendas dos produtos da sua empresa. Funciona integrado com o seu software de faturação, permitindo a atualização diária de informação acerca de compras e vendas da sua cadeia de lojas.
                </p>
              </div>
            </div>
          </div>

          <div className="solution">
            <img className="solution-logo" src="/static/images/ltgestaostock.svg" />
            <div className="solution-info">
              <h3 className="title">LT Gestão de Stock</h3>
              <div>
                <p>
                  Está constantemente a perder os prazos de entrega de produtos por falta de stock? Quer facilitar a gestão de stock da sua empresa?
                </p>
                <p>
                  Conheça o LT Gestão de Stock, um programa que lhe permite receber ALERTAS AUTOMÁTICOS e assim estar a par da situação do stock para fornecimento aos seus clientes. Esta ferramenta funciona de forma integrada com o seu software de faturação.
                </p>
              </div>
            </div>
          </div>

          <div className="solution">
            <img className="solution-logo" src="/static/images/conectorsagewoo.svg" />
            <div className="solution-info">
              <h3 className="title">Conector Wordpress &lt; &gt; SAGE</h3>
              <div>
                <p>
                  O Conector Wordpress &lt; &gt; SAGE foi desenvolvido para permitir uma melhor ligação entre uma loja online em WooCommerce e o programa de faturação SAGE Retail ou SAGE Gestão Comercial. Este software possibilita a sincronização de artigos e stock e a importação de encomendas feitas na loja online no sistema de faturação.
                </p>
              </div>
            </div>
          </div>

          <div className="solution">
            <img className="solution-logo" src="/static/images/conectorsageoc.svg" />
            <div className="solution-info">
              <h3 className="title">Conector OpenCart &lt; &gt; SAGE</h3>
              <div>
                <p>
                  O Conector OpenCart &lt; &gt; SAGE foi desenvolvido para permitir uma melhor ligação entre uma loja online em Opencart e o programa de faturação SAGE Retail ou SAGE Gestão Comercial. Este software possibilita a sincronização de artigos e stock e a importação de encomendas feitas na loja online no sistema de faturação.
                </p>
              </div>
            </div>
          </div>

          <div className="solution">
            {/*<img className="solution-logo" src="/static/images/software.svg" />*/}
            <div className="solution-info">
              <h3 className="title">Apoio à Gestão dos Comerciais</h3>
              <div>
                <p>
                  Esta solução, desenvolvida para funcionamento em tablet com sistema operativo Android, permite aos vendedores e responsáveis comerciais:
                </p>
                <ul>
                  <li>consultar as fichas dos clientes com todas as informações comerciais;</li>
                  <li>consultar e analisar, por situação de estado (pendente, aprovado, não aprovado), os orçamentos e as encomendas;</li>
                  <li>consultar as facturas emitidas por cliente assim como os valores em aberto em conta corrente;</li>
                  <li>consultar a ficha dos produtos assim como a disponibilidade de stock por armazém;</li>
                  <li>o envio por email da informação de cada documento incluindo a informação da conta corrente;</li>
                  <li>analisar as vendas por vendedor e as vendas por cliente.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

SoftwarePageComponent.displayName = 'SoftwarePageComponent';

// Uncomment properties you need
// SoftwarePageComponent.propTypes = {};
// SoftwarePageComponent.defaultProps = {};

export default SoftwarePageComponent;



// WEBPACK FOOTER //
// ./src/components/SoftwarePageComponent.js